import { ContainerClient } from "@azure/storage-blob";

const blobSasUrl = "https://dssstorageaccountprod01.blob.core.windows.net/user-image-storage?sp=racwdli&st=2025-04-07T19:44:41Z&se=2029-12-30T23:00:00Z&spr=https&sv=2024-11-04&sr=c&sig=2wyha5%2FPsWcFES9dQ99OySkxm%2BMvU5Ig1XWZSQH0i%2B8%3D"

function getContainerClient(): ContainerClient {
    return new ContainerClient(blobSasUrl);
}

function normalizeBlobName(fileName: string | null | undefined): string {
    return (fileName ?? "").trim();
}

function isBlobMissingError(error: unknown): boolean {
    if (!error || typeof error !== "object") {
        return false;
    }

    const storageError = error as {
        statusCode?: number;
        code?: string;
        details?: { errorCode?: string };
    };

    return storageError.statusCode === 404
        || storageError.code === "BlobNotFound"
        || storageError.details?.errorCode === "BlobNotFound";
}


export async function uploadImageToBlobStorage(
    fileName: string,
    fileData: Uint8Array
): Promise<void> {
    const normalizedFileName = normalizeBlobName(fileName);
    if (!normalizedFileName) {
        console.warn("Skipping image upload because blob name is empty.");
        return;
    }

    const containerClient = getContainerClient();
    const blockBlobClient = containerClient.getBlockBlobClient(normalizedFileName);

    try {
        await blockBlobClient.uploadData(fileData);
        console.log("Image uploaded successfully!");
    } catch (error) {
        console.error("Error uploading image:", error);
    }
}

export async function downloadImageFromBlobStorage(
    fileName: string
): Promise<Uint8Array> {
    const normalizedFileName = normalizeBlobName(fileName);
    if (!normalizedFileName) {
        return new Uint8Array();
    }

    const containerClient = getContainerClient();
    const blockBlobClient = containerClient.getBlockBlobClient(normalizedFileName);

    try {
        const downloadBlockBlobResponse = await blockBlobClient.download(0);
        if (!downloadBlockBlobResponse.blobBody) {
            throw new Error("No data in blobBody");
        }

        const blobData = await downloadBlockBlobResponse.blobBody;
        const arrayBuffer = await blobData.arrayBuffer();
        const fileData = new Uint8Array(arrayBuffer);

        console.log("Image downloaded successfully!");
        return fileData;
    } catch (error) {
        if (isBlobMissingError(error)) {
            console.warn(`Image blob not found: ${normalizedFileName}`);
            return new Uint8Array();
        }

        console.error("Error downloading image:", error);
        return new Uint8Array();
    }
}

export async function deleteImageFromBlobStorage(
    fileName: string
): Promise<void> {
    const normalizedFileName = normalizeBlobName(fileName);
    if (!normalizedFileName) {
        return;
    }

    const containerClient = getContainerClient();
    const blockBlobClient = containerClient.getBlockBlobClient(normalizedFileName);

    try {
        await blockBlobClient.delete();
        console.log("Image deleted successfully!");
    } catch (error) {
        if (isBlobMissingError(error)) {
            console.warn(`Image blob already missing: ${normalizedFileName}`);
            return;
        }

        console.error("Error deleting image:", error);
    }
}

export async function deleteImagesStartingWith(prefix: string): Promise<void> {
    const normalizedPrefix = normalizeBlobName(prefix);
    if (!normalizedPrefix) {
        return;
    }

    const containerClient = getContainerClient();
    try {
        for await (const blob of containerClient.listBlobsFlat({
            prefix: normalizedPrefix,
        })) {
            const blockBlobClient = containerClient.getBlockBlobClient(
                blob.name
            );
            await blockBlobClient.delete();
            console.log(`Deleted blob with name: ${blob.name}`);
        }
    } catch (error) {
        console.error("Error deleting images:", error);
    }
}
